import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteAntibiotic } from './DeleteAntibiotic';
import { FormAntibiotic } from './FormAntibiotic';
import { Dialog } from 'primereact/dialog';

export const ModalAntibiotic = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        antibiotic,
        handleInputChange, loading,
        saveCreate, saveUpdate,closeDialog, aware
    } = props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='tiny-dialog'
        >

            {
                method === "create"
                    ? <FormAntibiotic
                        button={"Crear antibiotico"}
                        {...{ closeDialog, loading, handleInputChange,aware, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormAntibiotic
                            button={"Actualizar antibiotico"}
                            {...{ closeDialog, loading, handleInputChange, validaciones,aware, methodAction: saveUpdate, antibiotic, }} />
                        :
                        // <DeleteAntibiotic {...{ toggle, loading, antibiotic, saveDelete }} />
                        null
            }
        </Dialog>
    )
}
